export class AutoPayCancel {
  public AccountNumber?: string;
  public RecurringScheduleId?: string;
  public CustomerClass?: string;
}
